import React, { memo } from 'react'
import { Box } from '@mui/material'

const ZoomableImage = memo(
  ({
    imageUrl,
    alt,
    scale,
    position,
    isDragging,
    imageRef,
    onMouseDown,
    onMouseMove,
    onMouseUp,
    onMouseLeave,
    onWheel,
    onTouchStart,
    onTouchMove,
    onTouchEnd,
    isOpen
  }) => {
    return (
      <Box
        ref={imageRef}
        component='img'
        src={imageUrl}
        alt={alt || 'Image'}
        onClick={e => e.stopPropagation()}
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseLeave}
        onWheel={onWheel}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        sx={{
          display: 'block',
          borderRadius: '4px',
          boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.5)',
          cursor: isDragging
            ? 'grabbing'
            : scale >
                (imageRef.current && imageRef.current.dataset.fitScale
                  ? parseFloat(imageRef.current.dataset.fitScale)
                  : 1) +
                  0.001
              ? 'grab'
              : 'default',
          transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
          transition: isDragging ? 'none' : 'transform 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
          userSelect: 'none',
          touchAction: 'none',
          opacity: isOpen ? 1 : 0,
          animation: isOpen ? 'zoomInOpacity 0.2s ease-out' : 'none',
          '@keyframes zoomInOpacity': {
            '0%': {
              opacity: 0
            },
            '100%': {
              opacity: 1
            }
          }
        }}
      />
    )
  }
)

ZoomableImage.displayName = 'ZoomableImage'
export default ZoomableImage
